import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { deleteWithTokenAPI, getWithTokenAPI } from "../../Util/Api";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import "../../Style/Pages/Role.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { MdDoNotDisturbAlt } from "react-icons/md";
// import { TableSkeleton } from "../Skeleton/Skeleton";

const RoleManagement = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const permission = auth.permission;

  const fetchRoles = async () => {
    try {
      setLoading(true);
      const res = await getWithTokenAPI(token, "/role/list ");
      setRoles(res?.data?.roles || []);
      console.log(res?.data, "Roles Response");
    } catch (error) {
      console.log("Error fetching roles", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [token]);

  const handleDelete = async (roleId) => {
    try {
      const response = await deleteWithTokenAPI(
        token,
        `/role/delete/${roleId}`,
      );

      if (response?.statusCode == 200) {
        fetchRoles(); // refresh list
        toast.success("Role deleted successfully");
      } else {
        toast.error(response?.message || "Failed to delete role");
      }
    } catch (error) {
      console.error("Error deleting role:", error);
      toast.error("Something went wrong while deleting");
    }
  };

  const handleEdit = (role) => {
    navigate(`/admin/roles/edit/${role._id}`);
    console.log("Edit role:", role);
  };

  const handleCreate = () => {
    navigate("/admin/roles/create");
  };

  return (
    <div className="role-management-container">
      <div className="role-management-header">
        <h2 className="role-management-title">Role Management</h2>
        {permission?.rolemanagement?.create && (
          <button className="btn-create-role" onClick={handleCreate}>
            <FaPlus className="create-icon" />
            Create
          </button>
        )}
      </div>

      <div className="role-table-wrapper">
        <table className="role-table">
          <thead className="role-table-header">
            <tr>
              <th className="role-table-th">S No</th>
              <th className="role-table-th">Role Name</th>
              <th className="role-table-th">Created Date</th>
              <th className="role-table-th">Permissions Count</th>
              <th className="role-table-th">Actions</th>
            </tr>
          </thead>

          <tbody className="role-table-body">
            {loading ? (
              <tr>
                <td colSpan="5" className="role-table-loading">
                  {/* <TableSkeleton columns={[]} color={"#8c1007"} /> */}
                </td>
              </tr>
            ) : roles.length > 0 ? (
              roles.map((role, index) => (
                <tr key={role._id} className="role-table-row">
                  <td className="role-table-td">{index + 1}</td>
                  <td className="role-table-td role-name-cell">{role.title}</td>
                  <td className="role-table-td">
                    {new Date(role.createdAt).toLocaleDateString()}
                  </td>
                  <td className="role-table-td">
                    <span
                      className={`role-status-badge ${role.status ? "status-active" : "status-inactive"}`}
                    >
                      {role?.permissionSummary?.totalTrue} Permissions
                    </span>
                  </td>
                  <td className="role-table-td role-actions-cell">
                    {permission?.rolemanagement?.update ? (
                      <button
                        className="role-action-btn btn-edit"
                        onClick={() => handleEdit(role)}
                        title="Edit Role"
                      >
                        <FaEdit className="action-icon" />
                      </button>
                    ) : (
                      <MdDoNotDisturbAlt style={{fontSize:'20px',marginTop:"10px"}}/>
                    )}

                    {permission?.rolemanagement?.delete ? (
                      <button
                        className="role-action-btn btn-delete"
                        onClick={() => handleDelete(role._id)}
                        title="Delete Role"
                      >
                        <FaTrash className="action-icon" />
                      </button>
                    ) : (
                      <MdDoNotDisturbAlt style={{fontSize:'20px',marginTop:"10px"}}/>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="role-table-empty">
                  <div className="empty-state-message">No Roles Found</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RoleManagement;
